import { ApolloLink } from "@apollo/client"
import { RetryLink } from "@apollo/client/link/retry"
import SerializingLink from "apollo-link-serialize"

import { AuthorizationType } from "client/types"
import authMiddlewareLink from "./authMiddlewareLink"
import environmentLink from "./environmentLink"
import errorLink from "./errorLink"
import fileUploadEnabledLink from "./fileUploadEnabledLink"
import loggerLink from "./loggerLink"
import offlineDocumentLink from "./offlineDocumentLink"
import offlineSignatureLink from "./offlineSignatureLink"
import appStateContextLink from "./appStateContextLink"
import tokenAuthLink from "./tokenAuthLink"
import { shouldRetryRequest } from "./retryPolicy"

export {
  appStateContextLink,
  authMiddlewareLink,
  environmentLink,
  errorLink,
  fileUploadEnabledLink,
  loggerLink,
  offlineDocumentLink,
  offlineSignatureLink
}

const baseLink = ApolloLink.from([
  appStateContextLink,
  loggerLink,
  errorLink,
  // @ts-ignore
  new SerializingLink(),
  new RetryLink({
    attempts: shouldRetryRequest
  }),
  offlineDocumentLink,
  offlineSignatureLink,
  environmentLink
])

const cognitoLink = ApolloLink.from([authMiddlewareLink, fileUploadEnabledLink])

const jwtLink = ApolloLink.from([tokenAuthLink, fileUploadEnabledLink])

const link = baseLink.split(
  operation =>
    AuthorizationType.Jwt === operation.getContext().appState.authorization,
  jwtLink,
  cognitoLink
)

export default link
